<script>
import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import CreditCardForm from '../CreditCardForm.vue';
import InfoCard from '../InfoCard.vue';

export default {
  name: 'MembershipPaymentMethod',
  components: { CreditCardForm, InfoCard },
  setup() {
    const store = useStore();
    const editCard = ref(false);
    const card = computed(() => store.state.account.paymentMethod?.card ?? null);
    const cardError = computed(() => store.state.cardOnFileError);
    const hasOwnership = computed(() => store.getters.hasOwnership);

    const toggleEdit = () => {
      editCard.value = !editCard.value;
      store.commit('CREATE_CARD_ERROR', '');
    };

    return {
      editCard, card, cardError, hasOwnership, toggleEdit,
    };
  },
};
</script>

<template>
  <InfoCard icon="credit-card" title="Payment Method">
    <div v-if="hasOwnership">
      <div v-if="editCard">
        <CreditCardForm @cardCreated="toggleEdit" @formCancelled="toggleEdit" />
      </div>
      <div v-else-if="card">
        <div class="membership-payment-method__card-row">
          <span class="membership-payment-method__brand-badge">{{ card.brand }}</span>
          <div class="membership-payment-method__card-info">
            <span class="membership-payment-method__card-name">{{ card.brand }} ending in {{ card.last4 }}</span>
            <span class="membership-payment-method__expiry">Expires {{ card.exp_month }}/{{ card.exp_year }}</span>
          </div>
        </div>
        <button
          class="membership-payment-method__update-link"
          @click="toggleEdit"
        >
          + Update payment method
        </button>
      </div>
      <div v-else>
        <p class="membership-payment-method__no-card">No payment method on file.</p>
        <button class="membership-payment-method__update-link" @click="toggleEdit">
          + Add payment method
        </button>
      </div>
      <p v-if="cardError" class="membership-payment-method__error">{{ cardError }}</p>
    </div>
    <p v-else class="membership-payment-method__restricted">
      Only the account owner can make payment changes.
    </p>
  </InfoCard>
</template>

<style lang="scss" scoped>
.membership-payment-method {
  &__card-row {
    display: flex;
    align-items: center;
    gap: 1rem;
    border: 1px solid $fc-greyscale-300;
    border-radius: $input-radius;
    padding: 0.75rem 1rem;
    margin-bottom: 1rem;
  }

  &__brand-badge {
    background-color: $color-black;
    color: $color-white;
    font-size: 0.6rem;
    font-family: $font-stack-heading;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    padding: 0.25rem 0.5rem;
    border-radius: 3px;
    white-space: nowrap;
  }

  &__card-info {
    display: flex;
    flex-direction: column;
    gap: 0.2rem;
  }

  &__card-name {
    font-size: 0.875rem;
    color: $color-black;
    text-transform: capitalize;
  }

  &__expiry {
    font-size: 0.75rem;
    color: $fc-greyscale-700;
  }

  &__update-link {
    background: none;
    border: none;
    padding: 0;
    font-size: 0.825rem;
    color: $color-red;
    cursor: pointer;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  &__no-card {
    font-size: 0.875rem;
    color: $fc-greyscale-700;
    margin: 0 0 0.75rem;
  }

  &__error {
    color: $color-red;
    font-size: 0.8rem;
    margin-top: 0.5rem;
  }

  &__restricted {
    font-size: 0.875rem;
    color: $fc-greyscale-700;
  }
}
</style>
